import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatGridListModule } from '@angular/material/grid-list';
import { finalize, map, Observable, of, tap } from 'rxjs';
import { VendorService } from '../../services/vendor-service';
import { RouterModule } from '@angular/router';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { AttachInvoiceDialogComponent } from '../attach-invoice-dialog/attach-invoice-dialog.component';
import { DownloadAttachmentsComponent } from '../download-attachments/download-attachments.component';
import { MatSpinner } from '@angular/material/progress-spinner';
import { MatPaginatorModule } from '@angular/material/paginator';


@Component({
  selector: 'app-vendor-dashboard',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatGridListModule,
    RouterModule,
    MatDialogModule,
    MatSpinner,
    MatPaginatorModule
  ],
  templateUrl: './vendor-dashboard.component.html',
  styleUrls: ['./vendor-dashboard.component.css']
})
export class VendorDashboardComponent {
  constructor(private vendorService: VendorService, private dialog: MatDialog) { } 
  displayedColumns: string[] = [
    'slno',
    'purchase_id',
    // 'purchase_report_data',
    'date',
    'amount_untaxed',
    'bill_status',
    'billno',
    'filename'
  ];
  isLoading = false;
  purchaseOrders$!: Observable<any[]>;

  pageSize = 10;
  pageIndex = 0;

  ngOnInit() {
    this.getPurchaseOrders();
  }
  
  getPurchaseOrders() {
    this.isLoading = true;
    this.purchaseOrders$ = this.vendorService.getPurchaseOrders().pipe(
      map((res: any) => res.result.data),
      finalize(() => this.isLoading = false)
    );
  }

  openAttachDialog(order: any) {
    const dialogRef = this.dialog.open(AttachInvoiceDialogComponent, {   
      data: order,
      width: 'auto',
      maxWidth: '90vw',
      panelClass: 'custom-dialog-container'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log('Files uploaded:', result);        
        order.invoiceFileName = result.invoice?.name;
        order.deliveryNoteFileName = result.deliveryNote?.name;
      }
    });
  }

  openViewAttachDialog(order: any) {
    const dialogRef = this.dialog.open(DownloadAttachmentsComponent, {
      data: order,
      width: '900px',
      minWidth: '1000px',
      minHeight: '500px',
      maxHeight: '90vh',
      panelClass: 'custom-dialog-container'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {

      }
    });
  }

  onPageChange(event: any) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
  }

  downloadBase64File(base64Data: string, fileName: string) {
  if (!base64Data) {
    console.error("No file data to download");
    return;
  }

  try {
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: this.getMimeType(base64Data) });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName || "download";
    a.click();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Failed to decode Base64 file", err);
  }
}

private getMimeType(base64: string): string {
  // Check magic numbers for file type detection
  if (base64.startsWith("JVBERi0")) return "application/pdf"; // PDF
  if (base64.startsWith("iVBORw0")) return "image/png";        // PNG
  if (base64.startsWith("/9j/")) return "image/jpeg";           // JPG
  return "application/octet-stream"; // fallback
}


private triggerDownload(blob: Blob, fileName: string) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName || 'download';
  a.click();
  window.URL.revokeObjectURL(url);
}

}
